<template>
  <div>
    <div></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      plateformInfo: {},
      // sign: 'DGF/0IbKC55cszmPYymUlARBoaq8j3Y9Bf5/ZVYF+ULR1s5gkK3F1VycSqy7+J5JXpfRcJMJI9AERe9Q2NM0f8WOphpA4K3CAbEDwbY6epnWyvLgUWGjNRtYK6kuL5OzonfghQCikGqGpjD5GEMgXdOxpyKfmCqEtmfcfJLRmjs=',
      target: '',
      sign: '',
      userRoleIds: [],
      source: '',
      ruleForm: {
        // 是否保存密码
        isSavePass: false
      }
    };
  },
  created () {
    this.target = this.$route.query.target;
    this.source = this.$route.query.source;
    this.sign = encodeURIComponent(this.$route.query.sign);
    this.getPlateforminfo();
  },
  methods: {
    getPlateforminfo () {
      this.$axios
        .post('api/third/basic/info/login', {
          data: {
            sign: this.sign,
            target: this.target,
            source: this.source
          },
          version: 0
        })
        .then((res) => {
          if (res.status) {
            if (res.status) {
              this.$toast('登陆成功');
              this.$store.commit('setToken', res.data.token);
              if (
                res.data.userInfo.roleList.length < 1 &&
                res.data.userInfo.educationRoleList.length < 1
              ) {
                this.$router.push({ path: '/noauthority' });
                return;
              }
              if (res.data.userInfo.roleList.length) {
                const managecode = [
                  'TEAM_MANAGER',
                  'ORG_MANAGER',
                  'CLOUD_MANAGER',
                  'ADMINISTRAROR'
                ];
                res.data.userInfo.roleList.forEach((a, index) => {
                  managecode.forEach((b) => {
                    if (a.codeName === b) {
                      res.data.userInfo.roleList.splice(index, 1);
                    }
                  });
                });
                // 缓存数据第一个角色
                this.$store.commit(
                  'setRole',
                  res.data.userInfo.roleList[0].code +
                    '&' +
                    res.data.userInfo.roleList[0].url
                );
              } else if (res.data.userInfo.educationRoleList.length) {
                // 缓存数据第一个角色
                this.$store.commit(
                  'setRole',
                  res.data.userInfo.educationRoleList[0].code +
                    '&' +
                    res.data.userInfo.educationRoleList[0].url
                );
              }
              this.$store.commit('setUserInfo', res.data.userInfo);
              // 缓存登陆账号、密码
              this.savePassWord();
              this.saveRoletoCache(res.data);
            } else {
              this.$toast('登陆失败');
            }
          } else {
            this.$toast('登录失败');
          }
          // 缓存平台信息
          this.$axios
            .post('admin/mainpage/getmainpage', {
              data: {
                platformId: res.data.userInfo.platformId
              },
              version: 0
            })
            .then((res) => {
              this.$store.commit('setPlateformInfo', this.plateformInfo);
            });
        });
    },
    // 记住密码，相应处理缓存
    // 判断是否要记住密码，相应处理缓存
    savePassWord () {
      if (this.ruleForm.isSavePass) {
        this.$store.commit('saveLoginPassWord', {
          userName: this.username,
          passWord: this.password,
          isSavePass: this.ruleForm.isSavePass
        });
      } else {
        this.$store.commit('saveLoginPassWord');
      }
    },
    saveRoletoCache (data) {
      // 登录窗口模式
      if (data.targetFlag === '0') {
        this.$router.push(this.$store.state.role.split('&')[1]);
      } else {
        this.$store.commit(
          'setRole',
          data.targetMsg.code + '&' + data.targetMsg.url
        );
      }
      // 缓存用户信息
      this.$store.commit('setUserInfo', data.userInfo);
      if (data.targetFlag === '1') {
        this.$router.push({
          path: '/index/apply'
        });
        // this.$router.push({ path: '/mh_tablist' });
      } else if (data.targetFlag === '2') {
        this.$router.push({
          path: '/index/educate_index/educate'
        });
      } else {
        this.$router.push({
          path: '/er_index'
        });
        // this.$store.commit(
        //   'setRole',
        //   data.targetMsg.code + '&' + data.targetMsg.url
        // );
        // this.$router.push({
        //   path: data.targetMsg.url
        // });
      }
    }
  }
};
</script>

  <style lang="scss" scoped>
</style>

